/** Returns given param id optionally prefixed with id of given list. */
export const getParamId = (id: string, listId?: string) => {
  if (listId !== undefined && listId !== '') {
    return `${listId}.${id}`
  } else {
    return id;
  }
}

/** Get value for param with id optionally prefixed with id of given list. */
export const getParamValue = (id: string, params: URLSearchParams, listId?: string) => {
  return params.get(getParamId(id, listId));
}

/** Returns true if given id starts with given listId, false otherwise. */
export const hasListPrefix = (id: string, listId: string) => {
  return id.startsWith(`${listId}.`);
}